<template>
  <div class="container">
    <div class="g-p-30">
      <el-tabs v-model="tabNow">
        <el-tab-pane label="我的证书" name="1"></el-tab-pane>
      </el-tabs>

      <!--  我的证书  -->
      <div class="g-flex g-flex-wrap"
           v-loading="loading"
           element-loading-text="拼命加载中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.5)">
        <div class="certificate g-m-r-10 g-m-t-10" v-for="item in certificateDataList" :key="item">
          <div class="g-p-10">
            <el-image
                class="cer-img"
                :src="item.backImg"
                :preview-src-list="[item.backImg]">
            </el-image>
            <div class="g-text-center g-m-t-15 g-font-16">
              {{ item.subjectName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCertificateMyList} from "@/api/user";

export default {
  name: "my-papers",
  data() {
    return {
      tabNow: '1',
      certificateDataList: [],
      params: {},
      loading: false
    }
  },
  created() {
    this.queryCertificateMyList()
  },
  methods: {
    queryCertificateMyList() {
      this.loading = true
      getCertificateMyList().then(res => {
        this.certificateDataList = res
        this.loading = false
      }, error => {
        this.loading = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #ffffff;
  border-radius: 5px;
}

::v-deep .el-tabs__item.is-active {
  color: #000;
  font-size: 20px;
  font-weight: 500;
}

.certificate {
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);
  flex-wrap: wrap;
  .cer-img {
    width: 188px;
    height: 269px;
  }
}

</style>
